<template>
  <v-col cols="12 education-footer-container">
    <div v-for="(child, index) in childrenCalculated()" :key="index">
      <v-row>
        <v-col cols="12" class="pr-0 pb-0">
          <div class="education-name-title">
            <div class="d-flex flex-column education-flex">
              <span>{{ child.fullName }}</span>
              <div class="">
                <v-divider />
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pr-0 pb-4 md-pb-0">
          <div class="education-title">
            <span
              >Payout
              <span class="payout-amt d-block d-lg-inline">
                {{ formatCurrency(childQuote(child).cover_amount) }}
                <span
                  v-if="reasonForQuote(childQuote(child))"
                  class="title-icon"
                >
                  <v-img
                    :src="
                      require(`@/assets/${whitelabel.images.insuranceEducationInfoIcon}`)
                    "
                    class="info-icon mr-2"
                    contain
                  />
                </span>
              </span>
            </span>
          </div>
          <div class="education-text">
            <span>
              {{ annualyText(childQuote(child), child) }}
            </span>
          </div>
        </v-col>
        <v-col cols="4" class="pr-0">
          <div class="education-title">
            <span
              >Premium
              <span class="payout-amt d-block d-lg-inline">
                R
                {{ childQuote(child).monthly_premium.toFixed(0) | currency }}
                pm
              </span>
            </span>
          </div>
          <div class="education-text">
            <span>Amount you pay per month</span>
          </div>
        </v-col>
        <v-col
          cols="4"
          class="font-weight-medium text-right d-flex justify-end align-end"
        >
          <a
            v-if="
              index == childrenCalculated().length - 1 && children.length > 1
            "
            class="see-more"
            @click="toggleSeeMore()"
            >{{ !seeMore ? 'See more...' : 'See less...' }}</a
          >
        </v-col>
      </v-row>
      <v-row v-if="reasonForQuote(childQuote(child))" class="info-container">
        <v-col cols="12" class="pr-0 mt-0 pt-0 pb-2 d-flex align-center">
          <div>
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.insuranceEducationInfoIcon}`)
              "
              class="info-icon mr-2"
              contain
            />
          </div>
          <span>{{ reasonForQuote(childQuote(child)) }}</span>
        </v-col>
      </v-row>
    </div>
  </v-col>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'InsuranceCardEducationFooter',
    data(props) {
      return {
        seeMore: false,
        singleChildren: this.singleChildrenCalculated(props.peopleRelations),
        children: props.peopleRelations.children.sort((a, b) =>
          parseInt(a.id) > parseInt(b.id) ? 1 : -1
        ),
      };
    },
    props: {
      quote: {
        required: false,
        type: Object,
      },
      peopleRelations: {
        type: Object,
        required: true,
      },
    },
    methods: {
      childrenCalculated() {
        return this.seeMore ? this.children : this.singleChildren;
      },
      singleChildrenCalculated(relations) {
        const object = relations.children.sort((a, b) =>
          parseInt(a.id) > parseInt(b.id) ? 1 : -1
        );
        return [object[0]];
      },
      toggleSeeMore() {
        this.seeMore = !this.seeMore;
      },
      childQuote(child) {
        return this.childrenQuotes().filter(c => c.child_id == child.id)[0];
      },
      reasonForQuote(quote) {
        if (quote.reason) {
          return quote.reason;
        }
      },
      childrenQuotes() {
        return JSON.parse(this.quote.childrenQuotes);
      },
      yearsUntilChildIs18(child) {
        const birthdayThisYear = moment(child.dateOfBirth).set(
          'year',
          moment().year()
        );
        const turning18Date = moment(moment(child.dateOfBirth)).add(
          18,
          'years'
        );
        const yearsUntil18 = turning18Date.diff(birthdayThisYear, 'years');
        if (yearsUntil18 > 12) {
          return 12;
        } else {
          return yearsUntil18;
        }
      },
      annualyText(quote, child) {
        if (quote.reason) {
          return 'Amount paid annually';
        } else {
          return `Amount paid annually for ${this.yearsUntilChildIs18(
            child
          )} years`;
        }
      },
      formatCurrency(value) {
        if (isNaN(value)) {
          return 'R 0';
        }
        const intValue = Math.floor(value);
        const stringValue = intValue.toString();
        const formattedValue = stringValue.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ' '
        );
        return `R ${formattedValue}`;
      },
    },
  };
</script>

<style lang="scss">
  .quote-container {
    .info-section {
      .education-title {
        span {
          color: black;
          font-size: 15px;
          span {
            color: var(--v-quote-payout-green-base);
            font-weight: 600;
          }
        }
      }

      .education-name-title {
        font-weight: 700;
        color: #000000;
        span {
          font-size: 16px;
        }
      }

      .education-flex {
        width: fit-content;
      }

      .info-container {
        margin-top: 0px;
        margin-bottom: 18px;

        .info-icon {
          width: 10px;
          height: 10px;
        }

        span {
          font-size: 8px;
        }
      }
      .education-title {
        .title-icon {
          position: relative;
          display: inline-block;
        }
        .info-icon {
          top: -8px;
          width: 10px;
          height: 10px;
        }
      }
    }

    .learn-more {
      cursor: pointer;
      font-size: 15px;
    }

    .see-more {
      cursor: pointer !important;
      font-size: 12px;
    }
  }

  @media screen and (max-width: 599px) and (min-width: 0px) {
    .education-footer-container {
      .title-icon {
        left: -3px;
        top: 4px;
      }

      .education-flex span {
        font-size: 12px !important;
      }
      .education-title span {
        font-size: 12px !important;
        line-height: 15px;
      }
      .education-text {
        margin-top: 2px;
        line-height: 11px;
      }
      .education-text span {
        font-size: 10px !important;
      }
      .learn-more {
        font-size: 10px;
      }

      .see-more {
        font-size: 10px;
      }
    }
  }
</style>
